import {onChange, onClick, onEnter, onKeyUp} from '../../tools/templateTools'
import {confirmYesNo, toStringOrEmpty, toNumber} from '../../tools/tools'
import {createNewFromTemplate, scanForTemplates} from '../../tools/templates'
import {AbstractClass} from '../../tools/abstract_class'
import {ITaskTypeDto, taskTypeDataProvider, TaskTypeDto} from '../../model/tasktype'

const TaskType_Html_Prefix = 'settings-tasktype-'
const Template_TaskType = TaskType_Html_Prefix + 'template'

class TaskTypePage extends AbstractClass {
	private list: Array<ITaskTypeDto> = []
	private visible: Array<ITaskTypeDto> = []

	public fill(target: JQuery) {
		scanForTemplates([Template_TaskType])

		this.getContainerHtml().empty()
		this.list = []
		this.visible = []
		taskTypeDataProvider.loadListAll(taskTypes => {
			taskTypes
				.sort((a, b) => {
					const idA = a.customId ? parseInt(a.customId.replace('#', '')) : a.id
					const idB = b.customId ? parseInt(b.customId.replace('#', '')) : b.id
					return idA && idB ? idA - idB : 0
				})
				.forEach(taskType => {
					this.list.push(taskType)
					this.visible.push(taskType)
				})
			setTimeout(() => {
				this.updateTable()
			}, 150)
		}, true)

		onEnter(this.getAddCustomIdHtml(), this.handleAddNew)
		onEnter(this.getAddShortNameHtml(), this.handleAddNew)
		onEnter(this.getAddNameHtml(), this.handleAddNew)
		onClick(this.getAddBtnHtml(), this.handleAddNew)
		onKeyUp(this.getSearchHtml(), this.handleSearch)
	}

	private updateTable() {
		this.getContainerHtml().empty()
		this.visible.length && this.visible.forEach(taskType => this.createEntry(taskType))
	}

	private handleAddNew() {
		let name = this.getAddNameHtml().val()
		let customId = this.getAddCustomIdHtml().val()
		let shortName = this.getAddShortNameHtml().val()
		customId = toStringOrEmpty(customId)
		shortName = toStringOrEmpty(shortName)
		name = toStringOrEmpty(name)
		if (name.length <= 0) {
			return
		}
		this.getAddCustomIdHtml().val('')
		this.getAddShortNameHtml().val('')
		this.getAddNameHtml().val('')
		this.createNewEntry(customId, shortName, name)
	}

	private getSearchHtml(): JQuery {
		return this.getHtml('search')
	}

	private getContainerHtml(): JQuery {
		return this.getHtml('container')
	}

	private getAddBtnHtml(): JQuery {
		return this.getHtml('add-btn')
	}

	private getAddCustomIdHtml(): JQuery {
		return this.getHtml('add-customId')
	}

	private getAddShortNameHtml(): JQuery {
		return this.getHtml('add-shortName')
	}

	private getAddNameHtml(): JQuery {
		return this.getHtml('add-name')
	}

	private getHtml(postFix: string): JQuery {
		return $('#' + TaskType_Html_Prefix + postFix)
	}

	private filterSearch(_v: string): Array<ITaskTypeDto> {
		const _transformString = (str: string | null | undefined) => (str ? str.replace(/\s/g, '').toLowerCase() : '')
		const _testValue = (str: string | null | undefined, search: string): boolean =>
			_transformString(str).includes(_transformString(search))

		const _filterAttr = (_c: ITaskTypeDto) => _testValue(_c.customId, _v) || _testValue(_c.shortName, _v) || _testValue(_c.name, _v)

		return _v ? this.list.filter(item => _filterAttr(item)) : this.list
	}

	private handleSearch() {
		let search = this.getSearchHtml().val()
		search = toStringOrEmpty(search)
		this.visible = this.filterSearch(search)
		this.updateTable()
	}

	private createNewEntry(customId: string, shortName: string, name: string): JQuery {
		let taskType: ITaskTypeDto = new TaskTypeDto()

		taskType.customId = customId ? customId : null
		taskType.shortName = shortName ? shortName : null
		taskType.name = name
		taskTypeDataProvider.save(taskType)
		return this.createEntry(taskType)
	}

	private createEntry(taskTypeDto: ITaskTypeDto): JQuery {
		let template = createNewFromTemplate(Template_TaskType)
		let customIdHtml = template.find('.' + TaskType_Html_Prefix + 'customId')
		let shortNameHtml = template.find('.' + TaskType_Html_Prefix + 'shortName')
		let nameHtml = template.find('.' + TaskType_Html_Prefix + 'name')
		customIdHtml.val(toStringOrEmpty(taskTypeDto.customId))
		shortNameHtml.val(toStringOrEmpty(taskTypeDto.shortName))
		nameHtml.val(toStringOrEmpty(taskTypeDto.name))

		onChange(customIdHtml, () => {
			taskTypeDto.customId = toStringOrEmpty(customIdHtml.val())
			taskTypeDataProvider.save(taskTypeDto)
		})
		onChange(shortNameHtml, () => {
			taskTypeDto.shortName = toStringOrEmpty(shortNameHtml.val())
			taskTypeDataProvider.save(taskTypeDto)
		})
		onChange(nameHtml, () => {
			taskTypeDto.name = toStringOrEmpty(nameHtml.val())
			taskTypeDataProvider.save(taskTypeDto)
		})

		let removeBtn = template.find('.' + TaskType_Html_Prefix + 'remove-btn')
		onClick(removeBtn, () => {
			if (!confirmYesNo('Wirklich löschen? ' + taskTypeDto.name)) {
				return
			}
			taskTypeDataProvider.delete(toNumber(taskTypeDto.id))
			template.remove()
		})

		this.getContainerHtml().append(template)
		return template
	}
}

export const taskTypePage = new TaskTypePage()
